import { render, staticRenderFns } from "./CreateJob.vue?vue&type=template&id=6ece3a15&"
import script from "./CreateJob.vue?vue&type=script&lang=js&"
export * from "./CreateJob.vue?vue&type=script&lang=js&"
import style0 from "./CreateJob.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports